import {createAsyncThunk} from "@reduxjs/toolkit";
import axios from "axios";
import {USER_LOCALSTORAGE_KEY} from "../../../../../shared/const/localstorage";
import {HomeworkResponse} from "../../../types/homework/HomeworkAnswerSchema";
import {setHomeworkResponse} from "../../../slice/homework/HomeworkAnswer";


interface FetchHomeworkAnswerParams {
    lessonsId: string | number | undefined;
    studentId: string | number | undefined;
}

export const fetchHomeworkAnswer = createAsyncThunk<HomeworkResponse, FetchHomeworkAnswerParams>(
    "homework/fetchHomeworkAnswer",
    async ({lessonsId, studentId}: FetchHomeworkAnswerParams, thunkAPI) => {
        try {
            const authToken = localStorage.getItem(USER_LOCALSTORAGE_KEY);
            if (!authToken) {
                throw new Error("No token found in localStorage.");
            }
            const {token} = JSON.parse(authToken);

            const response = await axios.get<HomeworkResponse>(`/api/lessons/${lessonsId}/homework-answer/${studentId}`, {
                headers: {
                    Authorization: `Bearer ${token}`,
                },
            });


            if (response.data && response.data.success) {
                thunkAPI.dispatch(setHomeworkResponse(response.data))

                return response.data;

            } else {
                throw new Error("Error fetching homework answer."); // Обработка ошибки
            }


        } catch (error) {
            // Обработка ошибок
            // @ts-ignore
            return thunkAPI.rejectWithValue(error.message);
        }
    }
);